import React from "react";
import PageHeader from "@/components/PageHeader";
import PartnerRewardsManager from "@/components/PartnerRewardsManager";
import { useLang } from "@/context/LanguageContext";

export default function Rewards() {
  const { t } = useLang();
  return (
    <div data-testid="rewards-page">
      <PageHeader title={t("side.rewards")} subtitle={t("rw.pageSubtitle")} />
      <PartnerRewardsManager />
    </div>
  );
}
